// import required libraries
import $ from 'jquery';

// import components that run on every page

// import actions
import renderTooltipModal from './actions/renderTootipModal';
import renderMediaToolkit from './actions/renderMediaToolkit';

// Import Pages
import accessibility from './actions/accessibility';
import renderCarouselCta from './actions/renderCarouselCta';
import renderLargeCarousel from './actions/renderLargeCarousel';
import renderImageSlider from './actions/renderImageSlider';
import Header from './components/Header';
import PageFrontPage from './pages/PageFrontPage';
import PageNewsIndex from './pages/PageNewsIndex';
import PageRiversIndex from './pages/PageRiversIndex'
import PageStaffIndex from './pages/PageStaffIndex';
import PageMediaCentre from './pages/PageMediaCentre';
import PageResourcesIndex from './pages/PageResourcesIndex';
import PinnedShareIcons from './components/PinnedShareIcons';
import renderPhotoSlider from './actions/renderPhotoSlider';
import PageReportsIndex from "./pages/PageReportsIndex";
import PageCounter from './pages/PageCounter';

// call functions
Header($);
accessibility();
PageFrontPage($);
PinnedShareIcons($);

//React Pages
PageRiversIndex($);
PageNewsIndex($);
PageStaffIndex($);
PageMediaCentre($);
PageResourcesIndex($);
PageReportsIndex($);
PageCounter($);

//React Blocks
renderCarouselCta($);
renderLargeCarousel($);
renderImageSlider($);

// actions
renderTooltipModal($);
renderPhotoSlider($);
renderMediaToolkit($);
